import useT from "utils/useT"

const WelcomeCard = () => {
  const t = useT()
  return (
    <div className="card card-style mb-2">
      <div className="content">
        <p dir="auto">{t.submit.hero}</p>
      </div>
    </div>
  )
}

export default WelcomeCard
